import {
  KeyRound, SlidersHorizontal, UserCheck, Activity, Ban, ScrollText, ShieldCheck, Info,
} from "lucide-react";
import Reveal from "@/components/Reveal";
import { SectionLabel } from "@/components/common";
import { securityPrinciples } from "@/data/demoData";

const iconMap = { KeyRound, SlidersHorizontal, UserCheck, Activity, Ban, ScrollText };

export default function Security() {
  return (
    <div>
      <section className="relative overflow-hidden vora-hero-radial border-b border-white/8">
        <div className="absolute inset-0 vora-grid-bg opacity-40" aria-hidden />
        <div className="relative mx-auto max-w-5xl px-5 sm:px-8 py-24 lg:py-28 text-center">
          <Reveal>
            <span className="inline-flex items-center gap-2 rounded-full border border-[#4F8CFF]/25 bg-[#4F8CFF]/8 px-3.5 py-1.5">
              <ShieldCheck className="h-3.5 w-3.5 text-[#4F8CFF]" />
              <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-[#8fb4ff]">Security</span>
            </span>
            <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">
              Autonomy with <span className="vora-text-gradient">boundaries.</span>
            </h1>
            <p className="mt-6 max-w-2xl mx-auto text-lg text-slate-300">
              Give agents the ability to act without giving them unlimited financial access.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <SectionLabel>Security Principles</SectionLabel>
          </Reveal>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {securityPrinciples.map((p, i) => {
              const Icon = iconMap[p.icon];
              return (
                <Reveal key={p.title} delay={(i % 3) * 0.06}>
                  <div className="h-full vora-card vora-card-hover rounded-2xl p-6" data-testid={`security-principle-${i + 1}`}>
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#4F8CFF]/12 text-[#4F8CFF]">
                      <Icon className="h-5 w-5" />
                    </span>
                    <h3 className="mt-5 text-lg font-semibold text-white">{p.title}</h3>
                    <p className="mt-2 text-sm text-slate-400 leading-relaxed">{p.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-10 flex items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.02] p-5">
              <Info className="h-5 w-5 text-slate-400 shrink-0 mt-0.5" />
              <p className="text-sm text-slate-400 leading-relaxed">
                Vvvoraa makes no claims of certifications, regulatory approvals, licenses or security guarantees
                that have not been provided. Any compliance or certification status will be published here as
                it becomes available.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
